import React, { useState } from 'react';
import Modal from 'react-modal';

import VerifyEmail from './VerifyEmail';
import VerifyQr from './VerifyQr';
import VerifyLogin from './VerifyLogin';

Modal.setAppElement('#root');

type Props = {
  modalStatus: boolean
  closeModal: () => void
}

const ModalVerifyStudent: React.FC<Props> = ({ modalStatus, closeModal }) => {


  const [verifyType, setVerifyType] = useState<'email' | 'qr' | 'login'>('login');

  const afterOpenModal = () => { };

  const selfClose = (event: React.SyntheticEvent) => {
    event.preventDefault();
    closeModal();
  };

  return (
    <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Example Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="animated fadeInDown faster modal-verify-student"
    >
      <div className="modal-description">
        <h2>
          XÁC MINH TRẠNG THÁI SINH VIÊN CỦA BẠN<br />
          ĐỂ KÍCH HOẠT ĐẶC QUYỀN
        </h2>
        <div className='verify-student'>
          <div className="verify-student__type">
            <a href="#" className={verifyType === 'login' ? 'active' : ''} onClick={e => { e.preventDefault(); setVerifyType('login') }}>Xác minh bằng Microsoft/Google</a>
            <a href="#" className={verifyType === 'email' ? 'active' : ''} onClick={e => { e.preventDefault(); setVerifyType('email') }}>Xác minh bằng email sinh viên</a>
            <a href="#" className={verifyType === 'qr' ? 'active' : ''} onClick={e => { e.preventDefault(); setVerifyType('qr') }}>Xác minh bằng QR code</a>
          </div>
          <div className="verify-student__content-wrapper">
            <div className="verify-student__form">
              {verifyType === 'login' && <VerifyLogin />}
              {verifyType === 'email' && <VerifyEmail closeModal={closeModal} />}
              {verifyType === 'qr' && <VerifyQr />}
            </div>
          </div>
        </div>

      </div>
      <a onClick={event => selfClose(event)} className="close" data-dismiss="modal" aria-label="Close">
        ×
      </a>
    </Modal>
  )
}

export default ModalVerifyStudent
